import styled from 'styled-components';
import { Button } from '@app/src/common/Button';
import { SIZE } from '@app/src/ui';

interface Props {
  fixed?: boolean;
  isDisplay?: boolean;
}

export const ButtonActionsWrapper = styled.div`
  ${(props: Props) => props.fixed &&
    `
      position: fixed;
      z-index: 1000;
      width: 100%;
      bottom: 0;
      padding: 8px 15px;
      background: #fff;
      left: 0;
    `
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    margin-bottom: 15%;
  }
`;

export const ButtonPrevWrapper = styled(Button)`
  height: 44px;
  font-size: 12px;
  font-weight: 600;
  svg {
    flex: 0 0 auto;
    margin-right: 6px;
  }
  span {
    text-align: left;
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    height: 48px;
    font-size: 15px;
  }
`;

export const ButtonNextWrapper = styled(Button)`
  height: 44px;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  svg {
    transform: rotate(180deg);
    margin-left: 6px;
  }
  display: ${(props: Props) => props.isDisplay ? 'flex' : 'none'}

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    height: 48px;
    font-size: 15px;
  }
`;

export const Wrapper = styled.div`
  margin-top: auto;
`;